import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Fade, Typography, Box, Backdrop, Button, IconButton, TextField, MenuItem, ListItemText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InputField from '../formElements/InputField';
import { API, graphqlOperation } from 'aws-amplify';
import { createCodeTranslation, updateItemCategorymaster } from '../../graphql/mutations';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { listItemCategorymaster } from '../../graphql/queries';
import { LoadingButton } from '@mui/lab';
import { Category } from '@mui/icons-material';
import 'react-dropdown-tree-select/dist/styles.css';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import TreeDropdown from '../DropDown/CategoryDropDown';
import { createItemCategorymaster } from '../../graphql';
import { useCreateItemCategorymasterMutation } from '../../redux/apis/itemCategory.api';
import { useDispatch } from 'react-redux';
import { dashboardApi } from '../../redux/apis/dashboardApi';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  // p: 4,
  outline: 'none',
  // minWidth: "500px",
  '@media (min-width:600px)': {
    width: 'auto',
  },
  width: '90%',
};

const AddCategory = ({
  open,
  MainParent,
  setCheckedLabel,
  setStateS,
  params,
  setOpen,
  addparents,
  dataArr,
  setCategoryData,
  setCloseEvent,
  listCategory,
  FnAftrClose,
  IDparent,
  editDetails,
}) => {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [parentId, setPrentsId] = useState();
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    parent: '',
    category: '',
    errorStatus: {
      parent: false,
      category: false,
    },
    errorFields: {
      parent: '',
      category: '',
    },
  });
  let [parentData, setParentData] = useState();
  useEffect(() => {
    if (IDparent) {
      setState((prev) => ({
        ...prev,
        parent: IDparent.id,
      }));
    }
    if (editDetails) {
      setState((prev) => ({
        ...prev,
        category: editDetails?.child?.category,
        parent: editDetails?.child?.itemcategorygroupid,
      }));
      setParentData({
        name: editDetails?.parent?.Category,
        category: 'Category',
        type: editDetails?.parent?.maincategory,
        id: editDetails?.parent?.itemcategoryid,
        parent: editDetails?.parent?.itemcategorygroupid,
        todo: editDetails?.child?.itemcategoryid,
        relatedData: {
          ItemCategoryID: editDetails?.parent?.itemcategoryid,
          CompanyID: editDetails?.parent?.companyid,
          EnteredTimeStamp: editDetails?.parent?.enteredtimestamp,
          ExpiredTimeStamp: editDetails?.parent?.expiredtimestamp,
          Category: editDetails?.parent?.category,
          ItemCategoryGroupID: editDetails?.parent?.itemcategorygroupid,
          MainCategory: editDetails?.parent?.maincategory,
        },
      });
    }
  }, [IDparent, editDetails]);
  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === 'category') {
      value = value?.toLowerCase().replace(/\b\w/g, (match) => match.toUpperCase());
    }
    if (value == '') {
      setState((prev) => ({
        ...prev,
        [name]: value,
        errorFields: {
          ...prev.errorFields,
          [name]: 'Category is required',
        },
        errorStatus: {
          ...prev.errorStatus,
          [name]: true,
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
        errorFields: {
          ...prev.errorFields,
          [name]: '',
        },
        errorStatus: {
          ...prev.errorStatus,
          [name]: false,
        },
      }));
    }

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    // console.log("dataArr1",dataArr);
    // dataArr.map((item) => {
    //     if (item.checked == true) {
    //         item.checked = false;
    //     }
    //     console.log('item?.children',item?.children);
    //     if(item?.children && item?.children?.length > 0) {

    //         item?.children.map((subitem)=> {
    //             if(subitem?.checked == true) {
    //             subitem.checked = false;
    //             }
    //         })
    //     }
    // })

    dataArr?.forEach((item) => {
      findCheckedValue(item);
    });
    setList(dataArr);
  }, [dataArr]);

  const findCheckedValue = (item) => {
    let arr = [];

    if (item?.checked == true) {
      // selected = item?.Category
      item.checked = false;
      //   item.isDefaultValue=false;
      // getSelectedNode(CategoryModalArray, item)
      //item.checked = false
      // if (item.ItemCategoryGroupID == 0) {
      // item.tagLabel = item.Category
      // }

      //   setState((prev) => ({
      //     ...prev,
      //     ["itemCtegorey"]:
      //       item.value == undefined ? "" : item.value,
      //     ["errorStatus"]: {
      //       ...prev.errorStatus,
      //       ["itemCtegorey"]: false,
      //     },
      //     ["errorFields"]: {
      //       ...prev.errorFields,
      //       ["itemCtegorey"]: "",
      //     },
      //   }));
    } else if (item?.children && item?.children?.length > 0) {
      for (let i = 0; i < item?.children?.length; i++) {
        findCheckedValue(item?.children[i]);
      }
    }
    // else {
    //   item.checked = false;
    //   setState((prev) => ({
    //     ...prev,
    //     ["itemCtegorey"]:
    //       item.value == '',
    //     ["errorStatus"]: {
    //       ...prev.errorStatus,
    //       ["itemCtegorey"]: false,
    //     },
    //     ["errorFields"]: {
    //       ...prev.errorFields,
    //       ["itemCtegorey"]: "",
    //     },
    //   }));
    // }
  };
  const [
    createCategory,
    { isLoading: isCreatingCategory, isError: isCreateCategoryError, isSuccess: isCreateCategorySuccess, error: createCategoryError },
  ] = useCreateItemCategorymasterMutation();
  async function createnewCategory(data) {
    try {
      let res;

      if (editDetails) {
        // res = await API.graphql(
        //   graphqlOperation(updateItemCategorymaster, {
        //     // updateItemCategorymasterInput: {
        //     //   ItemCategoryGroupID: data.ItemCategoryGroupID,
        //     //   Category: data.Category,
        //     //   ItemCategoryID: editDetails?.child?.ItemCategoryID
        //     // },
        //     updateItemCategorymasterInput: { ...data, ItemCategoryID: editDetails?.child?.ItemCategoryID },
        //   })
        // );
        res = {
          data: {
            updateItemCategorymaster: (
              await createCategory({
                createItemCategorymasterInput: {
                  ...data,
                  itemcategoryid: editDetails?.child?.itemcategoryid,
                },
              })
            ).data,
          },
        };
      } else {
        // res = await API.graphql(
        //   graphqlOperation(createItemCategorymaster, {
        //     createItemCategorymasterInput: data,
        //   })
        // );
        res = {
          data: {
            createItemCategorymaster: (await createCategory({ createItemCategorymasterInput: data })).data,
          },
        };
      }
      if (editDetails ? res.data.updateItemCategorymaster.statuscode == 'Error' : res.data.createItemCategorymaster.statuscode == 'Error') {
        setLoading(false);
        showWarningSnackbar(
          editDetails ? res.data.updateItemCategorymaster.statusmessage : res.data.createItemCategorymaster.statusmessage
        );
      } else {
        if (editDetails) {
          if (res?.data?.updateItemCategorymaster !== null) {
            setOpen(false);
            showSuccessSnackbar('Category Updated Successfully');
            dispatch(dashboardApi.util.invalidateTags(['Dashboard_itemCategoryMaster']));
            listCategory();
          }
        } else if (res?.data?.createItemCategorymaster?.itemcategoryid !== null) {
          if (setCategoryData !== undefined) {
            setCategoryData(res?.data?.createItemCategorymaster);
            if (setCloseEvent !== undefined) {
              setCloseEvent(false);
            }
          }
          let data = res.data.createItemCategorymaster;
          setCheckedLabel(data?.itemcategoryid);
          if (setStateS !== undefined) {
            if (IDparent) {
              setStateS([data.itemcategoryid]);
            } else {
              // setStateS(data.itemcategoryid);
              setStateS((prev) => ({
                ...prev,
                itemCtegorey: data.itemcategoryid,
              }));
            }
          }
          setOpen(false);
          showSuccessSnackbar('Category Created Successfully');
          dispatch(dashboardApi.util.invalidateTags(['Dashboard_itemCategoryMaster']));
          // setState({
          //     parent: '',
          //     category: '',
          //     errorStatus: {
          //         parent: false,
          //         category: false,
          //     },
          //     errorFields: {
          //         parent: '',
          //         category: '',
          //     }
          // })
          // setState((prev)=>({
          //     ...prev,
          //     parent: '',
          //     category: '',
          //     errorStatus: {
          //         ...prev.errorStatus,
          //         parent: false,
          //         category: false,
          //     },
          //     errorFields: {
          //         ...prev.errorFields,
          //         parent: '',
          //         category: '',
          //     }
          // }))
          setState((prev) => ({
            ...prev,
            ['parent']: '',
            ['category']: '',
          }));
          setLoading(false);
        } else {
          setLoading(false);
          showErrorSnackbar('Some thing went wrong !. Please try again');
        }

        // listCategory();
      }
    } catch (error) {
      setLoading(false);
      console.log('error', error);
    }
  }

  useEffect(() => {
    const handler = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        addNewCategory();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [state]);

  function addNewCategory() {
    const { parent, category } = state;
    const formData = {
      parent,
      category,
    };
    if (formValidation(formData)) {
      setLoading(true);
      let randomNumber = Math.floor(Math.random() * 100 + 1);
      let timeStamp = Math.floor(new Date().getTime() / 1000);
      const randomID = randomNumber + timeStamp.toString().slice(3, 10);
      let mainCategory;
      if (MainParent !== undefined) {
        mainCategory = MainParent.toLowerCase() == 'goods' ? 'Goods' : 'Services';
      } else {
        mainCategory = params?.row?.ItemType.toLowerCase() == 'goods' ? 'Goods' : 'Services';
      }
      const categoryData = {
        maincategory: mainCategory,
        category: category.charAt(0).toUpperCase() + category.slice(1),
        // CompanyID: 10001,
        // EnteredTimeStamp: Math.floor(new Date().getTime() / 1000),
        // ExpiredTimeStamp: Math.floor(new Date().getTime() / 1000),
        itemcategorygroupid: parent == '' ? parentId : parent,
        itemcategoryid: 0,
        expiredtimestamp: 0,

        // ItemCategoryID: Number(randomID)
      };

      createnewCategory(categoryData);
      // setState((prev) => ({
      //     ...prev,
      //     ['parent']: '',
      //     ['category']: '',
      // }))
    }
  }

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };

    Object.keys(data).map((itemKey) => {
      if (itemKey === 'category') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.category = 'Category is required';
          obj.errorStatus.category = true;
        } else {
          obj.errorFields.category = '';
          obj.errorStatus.category = false;
        }
      }
      // dataArr.map((item) => {
      //     if (item.Category.toLowerCase() === data.category.toLowerCase()) {
      //        // console.log('data.category.toLowerCase()',data.category.toLowerCase());
      //         isvalid = false;
      //         obj.errorFields.category = "Category  Already exists";
      //         obj.errorStatus.category = true;
      //     }
      // });
    });

    setState(obj);

    return isvalid;
  }

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      // setCloseEvent(true)
      setOpen(false);
      setState((prev) => ({
        ...prev,
        parent: '',
        category: '',
        errorStatus: {
          ...prev.errorStatus,
          parent: false,
          category: false,
        },
        errorFields: {
          ...prev.errorFields,
          parent: '',
          category: '',
        },
      }));
    }
    // setCategoryData([]);

    // setOpen(false);
  };

  // const findCheckedValue = (item) => {
  //    // console.log('called !!!!!')
  //     if (item?.Category == categoryData?.Category) {
  //       item.checked = false;
  //       item.tagLabel = ''

  //     } else if (item?.children && item?.children?.length > 0) {
  //       for (let i = 0; i < item?.children?.length; i++) {
  //         findCheckedValue(item?.children[i]);
  //       }
  //     }
  //   }

  // useEffect(()=> {
  //     dataArr1.forEach((item) => {
  //         findCheckedValue(item);
  //       })
  //      // console.log('dataArr1   :::: ',dataArr1)
  //       //setCategoryData('')
  // },[dataArr1])

  function categoryChange(currentNode) {
    setState((prev) => ({
      ...prev,
      ['parent']: currentNode?.value == undefined ? '' : currentNode?.value[1] == undefined ? currentNode?.value : currentNode?.value[1],
    }));
  }
  useEffect(() => {
    let element = document?.getElementById('category');
    element?.focus();
  }, []);
  return (
    <div
      id={open ? 'addCategory' : ''}
      onKeyDown={(e) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
          addNewCategory();
        }
        if (e.key === 'Tab') {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
    >
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={handleClose}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 15px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {editDetails ? 'Edit New Category' : 'Add New Category'}

                  <IconButton
                    aria-label="delete"
                    onClick={() => {
                      !loading && handleClose();
                    }}
                  >
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                padding: { xs: '5px', sm: '15px' },
                // height:{xs:"400px",sm:'auto'},
              }}
            >
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  {/* <TextField
                                    select
                                    id='parent'
                                    name='parent'
                                    label='Parent Category'
                                    variant="outlined"
                                    size='small'
                                    fullWidth
                                    value={state.parent}
                                    onChange={(e) => {
                                        const value = e.target.value

                                        setState( (prev) => ({
                                            ...prev,
                                            ['parent'] : value,
                                        }))
                                    }}
                                    sx={{
                                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                                            fontSize: '14px'
                                        },
                                        'label' :{
                                            fontSize: '14px'
                                        },
                                        '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root' :{
                                            fontSize: '14px'
                                        },
                                        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root' : {
                                            color:'input.font'
                                        },
                                        '.css-1d3z3hw-MuiOutlinedInput-notchedOutline' :{
                                            borderColor:'input.border'
                                        },                                      
                                        '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root' :{
                                            color:'input.font'
                                        },
                                        '.css-14qz1ij-MuiListItemText-root' : {
                                            margin:'0px'
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    {
                                        addparents.map( (ele,ind) => {
                                            return <MenuItem key={ind} value={`${ele.value}`}>
                                            <ListItemText sx={{margin:'0px',}} primary={ele.label} />
                                        </MenuItem>
                                        })
                                    }

                                </TextField> */}
                  <InputField
                    name="category"
                    id="category"
                    placeholder={editDetails ? 'Category' : 'New Category'}
                    size="small"
                    required={true}
                    type="text"
                    state={state}
                    value={state.category}
                    onChange={(e) => handleChange(e)}
                    onBlur={() => {
                      setState((prev) => ({
                        ...prev,
                        category: prev.category.replace(/\s+/g, ' ').trim(),
                      }));
                    }}
                  />
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TreeDropdown
                    parentDetails={editDetails ? parentData : IDparent}
                    MainParent={MainParent}
                    params={params}
                    SetPrentId={setPrentsId}
                    setup={'NotNeed'}
                    onChange={categoryChange}
                  />
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                // padding : "15px",
                // width:'100%',
                display: 'flex',
                justifyContent: 'space-between',
                // flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Button disabled={loading} onClick={handleClose} variant="outlined" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
                Cancel
              </Button>
              {/* <Button onClick={addNewCategory} variant='contained' sx={{flex:1,margin:'10px', fontSize : "12px"}} >Add</Button> */}
              <LoadingButton
                sx={{ flex: 1, margin: '10px', fontSize: '12px' }}
                loading={loading}
                disableRipple={true}
                variant="contained"
                onClick={() => addNewCategory()}
              >
                {editDetails ? 'Update' : 'Add'}
              </LoadingButton>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default AddCategory;
